import * as React from "react";

/** Measured size of the bracket wrapper; render the bracket only once `ready`. */
export default function useBracketViewport(ref) {
	const [size, setSize] = React.useState(null);

	React.useLayoutEffect(() => {
		const element = ref.current;
		const measure = () => {
			const next = {
				width: element.clientWidth,
				height: element.clientHeight,
			};
			setSize((prev) =>
				prev && prev.width === next.width && prev.height === next.height
					? prev
					: next
			);
		};

		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(element);
		return () => observer.disconnect();
	}, [ref]);

	return {
		ready: size != null,
		width: size?.width ?? 0,
		height: size?.height ?? 0,
	};
}
